import { Component } from 'react';

export default class Popover extends Component {
  render() {
    return null
  }
}